import FetchByObjectConfig from '../Helpers/FetchByObjectConfig';

export const saveCertificatesRequest = (body) => {
    const config = {
        path: 'certificates',
        method: 'POST',
        body,
    };
    return FetchByObjectConfig(config);
}

export const deleteCertificateRequest = (rfc) => {
    const config = {
        path: `certificates/${rfc}`,
        method: 'DELETE',
    };
    return FetchByObjectConfig(config);
}
